import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import formReducer from './slices/formSlice';
import reportReducer from './slices/reportSlice';
import referencesReducer from './slices/referencesSlice';
import modulesReducer from './slices/modulesSlice';
import contactFormReducer from './slices/contactFormSlice';
import countReducer from './slices/countSlice';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    form: formReducer,
    report: reportReducer,
    references: referencesReducer,
    modules: modulesReducer,
    contactForm: contactFormReducer,
    count: countReducer,
  },
  middleware: (getDefault) => getDefault().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
